export function isParaStudentExcludedFromReporting(row: unknown): boolean {
	if (row == null || typeof row !== 'object') {
		return true;
	}
	const o = row as Record<string, unknown>;
	if (o['exempt'] === true) {
		return true;
	}
	const c = Number(o['exemptCode'] ?? 0);
	return c !== 0;
}

export function filterParaReportingStudents<T>(students: readonly T[] | null | undefined): T[] {
	const list = Array.isArray(students) ? students : [];
	return list.filter((s) => !isParaStudentExcludedFromReporting(s));
}

export function isParaStudentMarkedExempt(row: unknown): boolean {
	if (row == null || typeof row !== 'object') {
		return false;
	}
	const o = row as Record<string, unknown>;
	if (o['exempt'] === true) {
		return true;
	}
	return Number(o['exemptCode'] ?? 0) !== 0;
}

export function countParaExemptMarkedStudents(students: readonly unknown[] | null | undefined): number {
	const list = Array.isArray(students) ? students : [];
	let n = 0;
	for (const s of list) {
		if (isParaStudentMarkedExempt(s)) {
			n++;
		}
	}
	return n;
}
